/*
 * File: OrderFiltersForm.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Shows and populates the orders filters form
 */
import React, { Component } from "react";
import UIFilterForm from "components/filter-view/UIFilterForm";
import UIProgress from "components/ui/UIProgress";
import OrderFormOptions from "../store/OrderFormOptions";
import FilterFields from "../FilterFields";
import FilterStore from "components/filter-view/FilterStore";
import References from "services/references/References";
import Users from "services/users/Users";
import PropTypes from "prop-types";
import OrdersAppStore from "services/orders/store/models/OrdersAppStore";
import { StoreContext } from "utils/useStore";
import Preferences from "services/preferences/Store";
class OrderFiltersForm extends Component {
  state = { loading: true };

  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.filterStore = FilterStore.create({ fields: FilterFields });
  }

  componentDidMount() {
    this.props.onRef(this);
    this.populateFilterModel();
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  /**
   * We need to update filter model options after we make api calls
   */
  async populateFilterModel() {
    const { signed, ...rest } = this.context.getPreference("ordersFilters");
    let signedIds;

    if (signed === "both") {
      signedIds = [1, 2];
    } else if (signed === false) {
      signedIds = [1];
    } else {
      signedIds = [2];
    }
    const filters = {
      signed: signedIds,
      ...rest
    };

    const references = this.context.getStore(References);
    // fetch filter input data
    let types = await OrderFormOptions.getTypes(this.context, true);
    let statuses = await OrderFormOptions.getStatuses(this.context, true);
    let offices = await references.forSelect("offices");
    let providers = await this.context.getStore(Users).forSelect("providers");

    // update the filter model options
    this.setFormOptions("types", types);
    this.setFormOptions("statuses", statuses);
    this.setFormOptions("providers", providers);
    this.setFormOptions("offices", [{ id: "0", name: "None" }, ...offices]);
    this.filterStore.mapDataToFormFields(filters);

    // we need to wait for the api responses before updating state
    this.setState({ loading: false });
  }

  setFormOptions(key, val) {
    let field = this.filterStore.fields.find(m => m.name === key);
    field.setOptions(val);
  }

  async submit() {
    let filters = {};
    this.filterStore.fields.forEach(field => {
      if (field.name === "signed") {
        if (field.isAllOptionsSelected()) {
          filters[field.name] = "both";
        } else {
          if (field.value.includes("1")) {
            filters[field.name] = false;
          } else {
            filters[field.name] = true;
          }
        }
      } else if (field.type === "checkboxgroup") {
        if (field.isAllOptionsSelected()) {
          filters[field.name] = "all";
        } else {
          filters[field.name] = field.value.map(value => parseInt(value));
        }
      } else {
        filters[field.name] = parseInt(field.value);
      }
    });
    await this.context.getStore(Preferences).apply("ordersFilters", filters);
    this.context.getStore(OrdersAppStore).refreshOrders();
  }

  content = () => {
    return <UIFilterForm fields={this.filterStore.fields} />;
  };

  render() {
    let { loading } = this.state;
    if (loading) return <UIProgress />;
    return <UIFilterForm fields={this.filterStore.fields} />;
  }
}

OrderFiltersForm.propTypes = {
  onRef: PropTypes.func.isRequired
};

export default OrderFiltersForm;
